module.exports = __webpack_public_path__ + "img/logo.a5376f3a.png";